import { render, staticRenderFns } from "./OrganisationDetailsForms.vue?vue&type=template&id=fa2c10f4&"
import script from "./OrganisationDetailsForms.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetailsForms.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDetailsForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports